export enum CustomerServicePermissions {
  ChCustomerService = "ChCustomerService",
  ChRequestsManagements = "ChRequestsManagements",
  ChOnlineRequestsManagements = "ChOnlineRequestsManagements",
  ChCustSerReports = "ChCustSerReports",
  ChAccessAllUsersCustomer = "ChAccessAllUsersCustomer",
  ChAccessAllBrancheCustomer = "ChAccessAllBrancheCustomer",
  ChCSEntryCorrection = "ChCSEntryCorrection",
  ChComplaintsRegistry = "ChComplaintsRegistry",
  ChOnlineRequests = "ChOnlineRequests",
  ChAlertCustomerServiceDeadline = "ChAlertCustomerServiceDeadline",
  ChCustomerServiceReadOnly = "ChCustomerServiceReadOnly",
}
